import { Button, Grid2, Modal } from "@mui/material";
import React from "react";
import "./index.scss";

const CustomModalConfirm = ({
  open,
  handleClose,
  textTitle = null,
  textBody = null,
  textConfirmButton,
  textCancleButton,
  functionConfirm = () => {},
}) => {
  const handleCloseModal = () => {
    handleClose(false);
  };

  return (
    <Modal open={open} className="modal-box-container-confirm">
      <Grid2
        className="parent-content-modal-confirm"
        container
        columns={12}
        dir="rtl"
      >
        {textTitle !== null && (
          <Grid2 className="title-text" item size={{ xs: 12 }}>
            {textTitle}
          </Grid2>
        )}
        {textBody !== null && (
          <Grid2 className="body-text" item size={{ xs: 12 }}>
            {textBody}
          </Grid2>
        )}

        <Grid2 className="box-button" container columns={12} spacing={1}>
          <Grid2 item size={{ xs: 6 }}>
            <Button className="reject" onClick={handleCloseModal}>
              {textCancleButton}
            </Button>
          </Grid2>
          <Grid2 item size={{ xs: 6 }}>
            <Button className="confirm" onClick={functionConfirm}>
              {textConfirmButton}
            </Button>
          </Grid2>
        </Grid2>
      </Grid2>
    </Modal>
  );
};

export default CustomModalConfirm;
